<h1>Sidebar</h1>
<app-sidebar-items layout="list"></app-sidebar-items>